export enum SubcategoriesEnum {
  COOLER_CPU = 36,
  CPU_AMD = 27,
  CPU_INTEL = 48,
}
